import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
} from "reactstrap";
import Select from "react-select";
import MaterialTable from "material-table";

//Context
import { useAuth } from "../../../context/auth";

//API
import {
  api_DELETE,
  api_GET,
  api_POST,
  api_PUT,
} from "../../../services/api_service";

//Services

import { showMessage, showQuestion } from "../../../services/message";

//Constants
import { table_translate } from "../../../constants/MaterialTable";
import { table_style } from "../../../constants/MaterialTable";

//Helpers
import mascaras from "../../../helpers/mascaras";

export default function TransportadoresPGRCC({
  item,
  opcao,
  handleProximoStep,
  handleStepAnterior,
}) {
  const { setLoading } = useAuth();
  const { handleSubmit } = useForm({ mode: "onBlur" });
  const [registro, setRegistro] = useState(null);

  const [transportadoresSelecionados, setTransportadoresSelecionados] =
    useState([]);
  const [optionsTransportadores, setOptionsTransportadores] = useState([]);
  const [selectedTransportador, setSelectedTransportador] = useState(null);
  const [todosTransportadores, setTodosTransportadores] = useState(false);
  const [todosTransportadoresSalvo, setTodosTransportadoresSalvo] =
    useState(false);

  useEffect(() => {
    if (item) {
      setRegistro(item);
      const todos = !!(opcao.tipoCadastro === "Requerimento"
        ? item?.requerimentoGerador?.[0]?.todosTransportadores
        : item?.protocoloGerador?.[0]?.todosTransportadores);
      setTodosTransportadores(todos);
      setTodosTransportadoresSalvo(todos);
      loadOptionsTransportadores();
    }
  }, [item]);

  async function loadOptionsTransportadores() {
    setLoading(true);
    try {
      const { data } = await api_GET(
        `ProtocoloTransportador/GetListProtocoloTransportador`
      );

      const isRequerimento = opcao.tipoCadastro === "Requerimento";

      // transportadores já salvos
      const transportadoresSalvos = isRequerimento
        ? item?.requerimentoGerador?.[0]
            ?.requerimentoGeradorTransportadoresPGRCC || []
        : item?.protocoloGerador?.[0]?.protocoloGeradorTransportadoresPGRCC ||
          [];

      const options = data.map((value) => {
        const encontrado = transportadoresSalvos.find(
          (t) => t.cnpjTransportador === value.cpf_Cnpj
        );

        return {
          label: value.razaoSocial,
          value: value.cpf_Cnpj,
          ...value,
          ...(isRequerimento && encontrado
            ? {
                requerimentoGeradorTransportadoresPGRCC_Id:
                  encontrado.requerimentoGeradorTransportadoresPGRCC_Id,
              }
            : {}),
          ...(!isRequerimento && encontrado
            ? {
                protocoloGeradorTransportadoresPGRCC_Id:
                  encontrado.protocoloGeradorTransportadoresPGRCC_Id,
              }
            : {}),
        };
      });

      setOptionsTransportadores(options);

      // Selecionar apenas os transportadores que foram salvos
      const selecionados = options.filter((opt) =>
        transportadoresSalvos.some((t) => t.cnpjTransportador === opt.value)
      );

      setTransportadoresSelecionados(selecionados);
    } catch (err) {
      showMessage("Erro", err?.message ?? "Erro na Operação!", "error", null);
    } finally {
      setLoading(false);
    }
  }

  function handleAdicionarTransportador() {
    if (!selectedTransportador) return;

    const existe = transportadoresSelecionados.some(
      (t) => t.value === selectedTransportador.value
    );
    if (existe) {
      showMessage(
        "Aviso",
        "Este transportador já foi adicionado.",
        "warning",
        null
      );
      return;
    }

    setTransportadoresSelecionados((prev) => [...prev, selectedTransportador]);
    setSelectedTransportador(null);
  }

  function handleCriarObjetoTipoRequerimento() {
    const requerimentoGeradorId =
      registro?.requerimentoGerador?.[0]?.requerimentoGerador_Id;

    return {
      requerimentoGeradorTransportadoresPGRCC: transportadoresSelecionados.map(
        (t) => ({
          requerimentoGeradorTransportadoresPGRCC_Id:
            t.requerimentoGeradorTransportadoresPGRCC_Id ?? 0,
          cnpjTransportador: t.cpf_Cnpj,
          requerimentoGerador_Id: requerimentoGeradorId,
        })
      ),
    };
  }

  function handleCriarObjetoTipoProtocolo() {
    const protocoloGeradorId =
      registro?.protocoloGerador?.[0]?.protocoloGerador_Id;

    return {
      protocoloGeradorTransportadoresPGRCC: transportadoresSelecionados.map(
        (t) => ({
          protocoloGeradorTransportadoresPGRCC_Id:
            t.protocoloGeradorTransportadoresPGRCC_Id ?? 0,
          protocoloGerador_Id: protocoloGeradorId,
          cnpjTransportador: t.cpf_Cnpj,
        })
      ),
    };
  }

  async function handleDeleteDestino(rowData) {
    showQuestion(
      "Aviso",
      "Tem certeza que deseja remover este transportador?",
      "question",
      async function (retorno) {
        if (!retorno) return;

        const isRequerimento = opcao.tipoCadastro === "Requerimento";
        const index = rowData?.tableData?.id;

        setLoading(true);
        try {
          // Remove via API se houver ID
          if (isRequerimento) {
            const id = rowData?.requerimentoGeradorTransportadoresPGRCC_Id;
            if (id) {
              await api_DELETE(
                `RequerimentoGerador/DeleteRequerimentoGeradorTransportadoresPGRCC/${id}`
              );
            }
          } else {
            const id = rowData?.protocoloGeradorTransportadoresPGRCC_Id;
            if (id) {
              await api_DELETE(
                `ProtocoloGerador/DeleteProtocoloGeradorTransportadoresPGRCC/${id}`
              );
            }
          }

          // Remove do array local com base no índice
          setTransportadoresSelecionados((prev) =>
            prev.filter((_, i) => i !== index)
          );

          setRegistro((prevRegistro) => {
            const novoRegistro = { ...prevRegistro };

            if (isRequerimento) {
              novoRegistro.requerimentoGerador[0].requerimentoGeradorTransportadoresPGRCC =
                novoRegistro.requerimentoGerador[0].requerimentoGeradorTransportadoresPGRCC.filter(
                  (_, i) => i !== index
                );
            } else {
              novoRegistro.protocoloGerador[0].protocoloGeradorTransportadoresPGRCC =
                novoRegistro.protocoloGerador[0].protocoloGeradorTransportadoresPGRCC.filter(
                  (_, i) => i !== index
                );
            }

            return novoRegistro;
          });
        } catch (err) {
          showMessage(
            "Erro",
            err?.message ?? "Erro ao excluir transportador",
            "error",
            null
          );
        } finally {
          setLoading(false);
        }
      }
    );
  }

  async function handleSalvarTodosTransportadores(isRequerimento) {
    if (isRequerimento) {
      await api_PUT(
        "RequerimentoGerador/PutRequerimentoGeradorTodosTransportadores",
        {
          gerador_Id:
            registro?.requerimentoGerador?.[0]?.requerimentoGerador_Id,
          todosTransportadores,
        }
      );
    } else {
      await api_PUT(
        "ProtocoloGerador/PutProtocoloGeradorTodosTransportadores",
        {
          gerador_Id: registro?.protocoloGerador?.[0]?.protocoloGerador_Id,
          todosTransportadores,
        }
      );
    }

    const registroAtualizado = { ...registro };
    const gerador = isRequerimento
      ? registroAtualizado.requerimentoGerador?.[0]
      : registroAtualizado.protocoloGerador?.[0];
    if (gerador) gerador.todosTransportadores = todosTransportadores;

    return registroAtualizado;
  }

  const onSubmit = async (data) => {
    const isRequerimento = opcao.tipoCadastro === "Requerimento";

    if (todosTransportadores) {
      setLoading(true);
      try {
        const registroAtualizado =
          await handleSalvarTodosTransportadores(isRequerimento);
        const gerador = isRequerimento
          ? registroAtualizado.requerimentoGerador?.[0]
          : registroAtualizado.protocoloGerador?.[0];
        if (gerador) {
          if (isRequerimento)
            gerador.requerimentoGeradorTransportadoresPGRCC = [];
          else gerador.protocoloGeradorTransportadoresPGRCC = [];
        }

        // a API apagou os vínculos: evita reaproveitar _Id inexistentes ao voltar para "Especificar"
        setTransportadoresSelecionados([]);
        setTodosTransportadoresSalvo(true);

        handleProximoStep(registroAtualizado);
      } catch (error) {
        showMessage(
          "Erro",
          error?.message ?? "Erro na operação",
          "error",
          null
        );
      } finally {
        setLoading(false);
      }
      return;
    }

    if (transportadoresSelecionados.length === 0)
      return showMessage(
        "Aviso",
        "Adicione pelo menos um transportador!",
        "warning",
        null
      );

    if (isRequerimento) {
      setLoading(true);
      try {
        if (todosTransportadoresSalvo)
          await handleSalvarTodosTransportadores(true);

        const objRequerimentoTransportadores =
          handleCriarObjetoTipoRequerimento();

        let transportadoresSalvos = [];

        for (const transportador of objRequerimentoTransportadores.requerimentoGeradorTransportadoresPGRCC) {
          let resposta;
          if (!transportador.requerimentoGeradorTransportadoresPGRCC_Id) {
            resposta = await api_POST(
              "RequerimentoGerador/PostRequerimentoGeradorTransportadoresPGRCC",
              transportador
            );
          } else {
            resposta = await api_PUT(
              "RequerimentoGerador/PutRequerimentoGeradorTransportadoresPGRCC",
              transportador
            );
          }

          if (resposta?.data) {
            transportadoresSalvos.push(resposta.data);
          }
        }

        const registroAtualizado = { ...registro };
        if (registroAtualizado.requerimentoGerador?.[0]) {
          registroAtualizado.requerimentoGerador[0].todosTransportadores = false;
          registroAtualizado.requerimentoGerador[0].requerimentoGeradorTransportadoresPGRCC =
            transportadoresSalvos;
        }

        handleProximoStep(registroAtualizado);
      } catch (error) {
        showMessage(
          "Erro",
          error?.message ?? "Erro na operação",
          "error",
          null
        );
      } finally {
        setLoading(false);
      }
    } else {
      setLoading(true);
      try {
        if (todosTransportadoresSalvo)
          await handleSalvarTodosTransportadores(false);

        const objProtocoloTransportadores = handleCriarObjetoTipoProtocolo();

        let transportadoresSalvos = [];

        for (const transportador of objProtocoloTransportadores.protocoloGeradorTransportadoresPGRCC) {
          let resposta;
          if (!transportador.protocoloGeradorTransportadoresPGRCC_Id) {
            resposta = await api_POST(
              "ProtocoloGerador/PostProtocoloGeradorTransportadoresPGRCC",
              transportador
            );
          } else {
            resposta = await api_PUT(
              "ProtocoloGerador/PutProtocoloGeradorTransportadoresPGRCC",
              transportador
            );
          }

          if (resposta?.data) {
            transportadoresSalvos.push(resposta.data);
          }
        }

        const registroAtualizado = { ...registro };
        if (registroAtualizado.protocoloGerador?.[0]) {
          registroAtualizado.protocoloGerador[0].todosTransportadores = false;
          registroAtualizado.protocoloGerador[0].protocoloGeradorTransportadoresPGRCC =
            transportadoresSalvos;
        }

        handleProximoStep(registroAtualizado);
      } catch (error) {
        showMessage(
          "Erro",
          error?.message ?? "Erro na operação",
          "error",
          null
        );
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <Card className="card-stats">
      <CardBody>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Container style={{ maxWidth: "1000px", margin: "0 auto" }}>
            <h2 className="titulo-solicitacao">Transportadores</h2>
            <Row>
              <Col md="12">
                <FormGroup tag="fieldset">
                  <FormGroup check inline>
                    <Label check>
                      <Input
                        type="radio"
                        name="selecaoTransportadores"
                        checked={todosTransportadores}
                        onChange={() => setTodosTransportadores(true)}
                      />{" "}
                      Todos
                    </Label>
                  </FormGroup>
                  <FormGroup check inline>
                    <Label check>
                      <Input
                        type="radio"
                        name="selecaoTransportadores"
                        checked={!todosTransportadores}
                        onChange={() => setTodosTransportadores(false)}
                      />{" "}
                      Especificar
                    </Label>
                  </FormGroup>
                </FormGroup>
              </Col>
            </Row>
            <Row className="align-items-end">
              <Col md="12" lg="9">
                <FormGroup>
                  <b>
                    <label>
                      <span className="text-danger">*</span> Selecione o
                      Transportador
                    </label>
                  </b>
                  <Select
                    options={optionsTransportadores}
                    value={selectedTransportador}
                    onChange={(option) => setSelectedTransportador(option)}
                    isDisabled={todosTransportadores}
                    placeholder="Selecione"
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                  />
                </FormGroup>
              </Col>
              <Col md="12" lg="3">
                <Button
                  color="primary"
                  type="button"
                  className="w-100"
                  disabled={todosTransportadores}
                  onClick={handleAdicionarTransportador}
                >
                  Adicionar <i className="fas fa-plus"></i>
                </Button>
              </Col>
            </Row>

            {!todosTransportadores && (
              <Row>
                <Col md="12">
                  <MaterialTable
                    title=""
                    columns={[
                      { title: "Razão Social", field: "razaoSocial" },
                      {
                        title: "CPF/CNPJ",
                        field: "cpf_Cnpj",
                        render: (rowData) =>
                          mascaras.cpfcnpjMask(rowData.cpf_Cnpj),
                      },
                      {
                        title: "Telefone",
                        field: "telefone",
                        render: (rowData) =>
                          mascaras.telefoneMask(rowData.telefone),
                      },
                    ]}
                    data={transportadoresSelecionados}
                    isLoading={false}
                    actions={[
                      {
                        icon: "delete",
                        tooltip: "Remover",
                        onClick: async (event, rowData) =>
                          handleDeleteDestino(rowData),
                      },
                    ]}
                    localization={table_translate}
                    options={{
                      ...table_style,
                      actionsColumnIndex: -1,
                    }}
                  />
                </Col>
              </Row>
            )}

            <Row>
              <Col lg="6" className="text-left">
                <Button
                  color="secondary"
                  onClick={() => handleStepAnterior(registro)}
                  className="btn-mobile"
                >
                  <i className="fas fa-chevron-left"></i> Voltar
                </Button>
              </Col>
              <Col lg="6" className="text-right">
                <Button color="success" className="btn-mobile" type="submit">
                  Próxima Etapa <i className="fas fa-chevron-right"></i>
                </Button>
              </Col>
            </Row>
          </Container>
        </Form>
      </CardBody>
    </Card>
  );
}
